import get from "lodash/get";
import set from "lodash/set";
import { batch } from 'react-redux';
import { updateForm } from "../actions";
export var UPDATE_CART = Symbol("UPDATE_CART");
export var updateCart = function (cartItems, callback, initiator) { return function (dispatch, getState) {
    batch(function () {
        dispatch({
            type: UPDATE_CART,
            cart_items: cartItems,
            initiator: initiator || getState().store.storeKey
        });
        var form = get(getState(), "formReducer.forms.cart", null);
        if (form) {
            dispatch(updateForm({
                name: 'cart',
                form: set(form, "booking_data.cart_items", cartItems)
            }, "cart actions"));
        }
    });
    if (callback)
        callback(get(getState(), "cartReducer.cart_items"));
}; };
